import React from "react";

export const TopicalSpeakers = () => { 

  return (
    <>
    <div className="uploaded-style">
      DETAILS UPDATED SHORTLY...
    </div>
    <hr className="hr-style" />
    </>
  );
};
